import { analyticsAxiosConfig } from "../../../config/axios.config"

export async function getPaymentPlans() {
	const response = await analyticsAxiosConfig.get(`/payments/plans`)
	const { data } = response
	return data
}
